import moment from "moment";

import { Col, Row, Container, Dropdown, DropdownButton } from "react-bootstrap";

const currentYear = moment().year();
const currentMonth = moment().month();

const Months = (props: { month: number; year: number }) => {
  const mts = moment.months().map((m, i) => (
    <Dropdown.Item
      key={i}
      eventKey={i}
      active={i === props.month}
      disabled={props.year === currentYear && i > currentMonth}>
      {m}
    </Dropdown.Item>
  ));

  return <>{mts}</>;
};

const Years = (props: { year: number }) => {
  const yrs = [0, -1, -2].map((y) => {
    const cy = y + currentYear;
    return (
      <Dropdown.Item eventKey={cy} active={cy === props.year} key={cy}>
        {cy}
      </Dropdown.Item>
    );
  });

  return <>{yrs}</>;
};

interface Props {
  selectedDate: Date;
  onChange: (d: Date) => void;
}

export const DateSelector: React.FunctionComponent<Props> = (props) => {
  const date = props.selectedDate;

  const monthName = moment(date).format("MMMM");
  const month = date.getMonth();
  const year = date.getFullYear();

  const update = (m: number, y: number) => props.onChange(new Date(y, m, 1));

  return (
    <Container>
      <Row>
        <Col>
          <DropdownButton
            title={monthName}
            onSelect={(m, _) => {
              if (m) update(parseInt(m), year);
            }}>
            <Months month={month} year={year} />
          </DropdownButton>
        </Col>
        <Col>
          <DropdownButton
            title={year}
            onSelect={(y, _) => {
              if (y) update(month, parseInt(y));
            }}>
            <Years year={year} />
          </DropdownButton>
        </Col>
      </Row>
    </Container>
  );
};
